import { useClientContext } from "./ClientWorkspace";
import { RunsView } from "../Activity";

/** Activity tab: every run for this client, narrowed to the pipelines in the
 *  selected environment. The same `RunsView` the all-clients page renders. */
export function ClientActivity() {
  const { org, env, pipelines } = useClientContext();
  return <RunsView organizationId={org.id} restrictToPipelineIds={env ? pipelines.map((p) => p.id) : undefined} />;
}
